import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './MajesticAdmin.css';
import './pages/MajesticCommon.css';
import App from './App';
import './i18n';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={<div>Loading...</div>}>
      <App />
    </Suspense>
  </React.StrictMode>
);